import { useState, useEffect } from 'react';
import CardLayout from '../../../components/utils/CardLayout';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../../../components/utils/Table'
import dailyPlanRequestActions from '../../../redux/dailyPlanRequest/actions'
import Modal from '../../../components/utils/Model';
import moment from "moment-timezone";
import Tag from '../../../components/utils/Tag'


const DailyPlanHistory = ({ row, modal, close }) => {
    const dispatch = useDispatch();
    const { getDprHistory } = dailyPlanRequestActions;
    const { dprhistoryLoading, dprhistoryResult } = useSelector((state) => state.dailyPlanRequest);

    useEffect(() => {
        dispatch(getDprHistory(row.ID));
    }, [])

    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'FROM DATE', key: 'fromDate' },
        { displayName: 'TO DATE', key: 'toDate' },
        { displayName: 'TYPE', key: 'type' },
        { displayName: 'REFUND/EXTEND AMOUNT', key: 'chargedAmount' },
        { displayName: 'ACTION BY', key: 'actionBy' },
        { displayName: 'ACTION AT', key: 'actionAt' },
    ];

    const dataSource = dprhistoryResult && dprhistoryResult.length > 0 && dprhistoryResult.map((item, key) => {
        return {
            key: key + 1,
            fromDate: item.FromDate !== null ? moment(item.FromDate, "YYYY-MM-DD").format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
            toDate: item.ToDate !== null ? moment(item.ToDate, "YYYY-MM-DD").format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
            type: (<Tag color={item.ActionType === 'EXTEND' ? 'badge-success' : 'badge-danger'} title={item.ActionType} />),
            chargedAmount: `$${item.ChargedAmount.toFixed(2)}`,
            actionBy: item.ActionBy,
            actionAt: item.CreatedDtTm !== null ? moment(item.CreatedDtTm).tz(process.env.REACT_APP_TIMEZONE).format(process.env.REACT_APP_LONG_TIME_FORMAT) : '',
        }
    });

    return (
        <Modal
            showModal={modal}
            title={`Extend & Reduce DPR History : ${row.TransactionID}`}
            onHide={() => close()}
            width={900}
            showFooter={false}
        >
            <div style={{ marginTop: "-20px" }}>
                <Table columns={columns} data={dataSource} loading={dprhistoryLoading} pagination={false} />
            </div>
        </Modal>
    )
}

export default DailyPlanHistory
